<template>
  <div>
    <div class="threeColumnGrid">
      <div>
        <span class="label">Date of joining</span>
        <date-picker @datevalue="(val)=>official.date_of_joining=val" :value="official.date_of_joining"></date-picker>
      </div>
      <txt label='Official Email Id' type="email" v-model="official.official_email_id"></txt>
       <!-- pending -->
      <tl-select
            label="Employee Category"
            labelText="name"
            :options="[{name:'Probation'}, {name:'Permanent'}, {name:'Contract'}, {name:'Consultant'}]"
            @change="(val)=>{official.category_data_json=val
                official.category_id=val.id}"
          >
      </tl-select>
      <!-- enum so correct -->
      <tl-select
            label="Skill Type"
            :options="['Highly skilled', 'Skilled', 'Semi skilled', 'Unskilled']"
            @change="(val)=>official.skill=val"
          >
      </tl-select>
      <!-- pending -->
      <tl-select label="Location"  labelText="name"
          :options="locationList"
            @change="(val)=>official.based_location_id=val.id"></tl-select>
      <!-- <tl-select label="BU Name *" 
           :options="['Full-time', 'Contract']" :value="official.skill"
            @change="(val)=>official.skill=val"></tl-select> -->
             <!-- done -->
      <tl-select 
          label="Cost Centre" 
           labelText="name"
           :options="costCenterList"
           @change="(val) => {official.cost_center_id = val.id}"
           ></tl-select>
            <!-- done -->
      <tl-select label="Designation"  labelText="name"
           :options="designationList"
            @change="(val) => official.designation_id = val.id"
           ></tl-select>
           <!-- done -->
      <tl-select label="Level"  labelText="name"
           :options="levelList"
            @change="(val) => official.level_id = val.id"
           ></tl-select>
      <tl-select
          label="Department"
          labelText="name"
          name="department"
          :options="departmentList"
          @change="(val) => official.buisiness_unit_id = val.id"
        ></tl-select>
         <!-- done -->
      <tl-select label="Grade" 
           :options="gradeList"
           labelText="name"
            @change="(val) => official.grade_id = val.id"></tl-select>
            <!-- done -->
      <tl-select label="Band *" 
           labelText="name"
           :options="bandList"
           @change="(val) => official.band_id = val.id"></tl-select>
            <!-- pending -->
      <tl-select label="Pay Group" 
           labelText="name"
           :options="paygroupList" 
            @change="(val)=>official.paygroup_id=val.id"
            ></tl-select>
      <txt label='Permanent Retirement Account Number' type="text" v-model="official.pran"></txt>
      <txt label='Reporting Manager' type="text" v-model="reporting_manager_id"></txt>
      <tl-select label="Disability" :options="['Yes', 'No']"
           @change="(val) => official.disability = val.id"></tl-select>
      <tl-select label="Vasectomyhhhh" :options="['Yes', 'No']"
           @change="(val) => official.vasectomy = val.id"></tl-select>
      <tl-select label="Reporting Manager" :options="reportingManagersList"
           @change="(val) => official.reportingManager = val.id"></tl-select>
    </div>
  </div>
</template>

<script>
import { mapActions,mapGetters, mapState } from 'vuex';
export default {
  data() {
    return {
      jobType: null,
      skillType:'',
      reportingManagersList: [],
      costCenterList: [],
      designationList: [],
      levelList: [],
      gradeList: [],
      departmentList: [],
      bandList: [],
      paygroupList:[],
      locationList:[],
      reporting_manager_id:'',
      official: {
        band_id: "",
        reportingManager: '',
        grade_id: "",
        designation_id: "",
        level_id: "",
        department_id: "",
        cost_center_id: "",
        paygroup_id:""
      }
    }
  },
  watch:{
    official:function(val) {
          //console.log('official',val)
          this.getDesignations();
          this.getLevels();
          this.getGrades();
          this.getBands();
          this.getDepartment();
          this.getCostCenter();
          this.$emit('official',val)
        },
     deep: true
  },
  computed:{
    ...mapState({
      officialInfo:state=>state.onboard.employees.record[0] ? state.onboard.employees.record[0].EmployeeOfficial : {}

    }),
    ...mapState("onboard/organization", {
      orgData: state => state.data[0]
    }),
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID"
    }),

    leId() {
        if (this.$route.params.entity_index)
          return this.getleid(this.$route.params.entity_index);
        else return this.getleid(0);
    }
  },
  mounted(){
    // this.getOfficialInformation();
  },
  activated(){
    //console.log('activatyed')
    this.getDesignations();
    this.getLevels();
    this.getGrades();
    this.getBands();
    this.getDepartment();
    this.getCostCenter();
    this.getPaygroups();
    this.getLocations();
  },
  methods:{
    ...mapActions({
      fetch_grades: "onboard/salary_grades/fetchAll",
      fetch_bands: "onboard/salary_bands/fetchAll",
      fetch_businessunits: "onboard/business_units/fetchAll",
      fetch_cost_center: "onboard/cost_centres/fetchAll",
      fetch_designation: "onboard/designations/fetchAll",
      fetch_level: "onboard/levels/fetchAll",
      fetch_paygroups:"onboard/paygroup/fetchAll",
      fetch_locations:"onboard/locations/fetchAll"
    }),

    getOfficialInformation(){
      //this.official['official_email_id']=this.
    },
    async getGrades() {
      try {
        let res = await this.fetch_grades(this.leId);
        if (res.data.status) {
          //console.log(res.data.payload);
          this.gradeList = res.data.payload.data;
          // this.gradeList.splice(0,0, {id:'', name:'All'});
        }
      } catch (error) {
        //console.log(error); 
      }
    },
    async getLocations() {
      try {
        let res = await this.fetch_locations(this.leId);
        if (res.data.status) {
          //console.log(res.data.payload);
          this.locationList = res.data.payload.data;
          // this.gradeList.splice(0,0, {id:'', name:'All'});
        }
      } catch (error) {
        //console.log(error); 
      }
    },
    async getBands() {
      try {
        let res = await this.fetch_bands(this.leId);
        if (res.data.status) {
          //console.log(res.data.payload);
          this.bandList = res.data.payload.data;
          // this.bandList.splice(0,0, {id:'', name:'All'});
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getPaygroups() {
      try {
        let res = await this.fetch_paygroups(this.leId);
        if (res.data.status) {
          //console.log(res.data.payload);
          this.paygroupList = res.data.payload.data;
          // this.bandList.splice(0,0, {id:'', name:'All'});
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getDepartment() {
      try {
        let res = await this.fetch_businessunits(this.orgData.id);
        if (res.data.status) {
          //console.log(res.data.payload);
          this.departmentList = res.data.payload.data;
          // this.departmentList.splice(0,0, {id:'', name:'All'});
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getCostCenter() {
      try {
        let res = await this.fetch_cost_center(this.leId);
        if (res.data.status) {
          //console.log(res.data.payload);
          this.costCenterList = res.data.payload.data;
          // this.costCenterList.splice(0,0,{id:'', name:'All'});
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getDesignations() {
      try {
        let res = await this.fetch_designation(this.leId);
        if (res.data.status) {
          //console.log(res.data.payload);
          this.designationList = res.data.payload.data;
          // this.designationList.splice(0,0,{id:'', name:'All'})
        }
      } catch (error) {
        //console.log(error);
      }
    },
    async getLevels() {
      try {
        let res = await this.fetch_level(this.leId);
        if (res.data.status) {
          //console.log(res.data.payload);
          this.levelList = res.data.payload.data;
        }
      } catch (error) {
        //console.log(error);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/scss/_variables.scss';
.label {
  font-size: $font-size-small;
  font-weight: 300;
  margin-bottom: 5px;
  color: #6e6e6e;
}

.radio-container {
  display: flex;
  flex-direction: column;
  margin: 25px 0px 25px 0px;
  color: #404040;
  font-size: $font-size-small;
  *:nth-child(n) {
    margin-bottom: 10px;
  }
}
.radio-btn {
  display: flex;
  *:nth-child(n) {
    margin-right: 20px;
  }
}
.margb {
  margin-bottom: 15px;
}
</style>
